module.exports = __webpack_public_path__ + "img/featuredartist (7).a8949f45.jpg";